import { ColorPaletteState } from '@sparemin/blockhead';
import React, { useMemo } from 'react';
import { AspectRatioName } from 'types';
import { AIGenerationTopSlot } from '../AIGeneration';
import { EngineRegistry, isTextToImageEngine } from '../types';

export interface UseImageSearchResultsTopSlotConfig {
  hasQuery: boolean;
  selectedEngine?: string;
  engines: EngineRegistry;
  aspectRatioName?: AspectRatioName;
  colorPaletteState: ColorPaletteState;
  onAspectRatioNameChange: (value: AspectRatioName) => void;
  onGenerate?: () => void;
}

export type UseImageSearchResultsTopSlotResult = React.ReactNode;

export default function useImageSearchResultsTopSlot({
  hasQuery,
  selectedEngine,
  engines,
  aspectRatioName,
  onAspectRatioNameChange,
  colorPaletteState,
  onGenerate,
}: UseImageSearchResultsTopSlotConfig): UseImageSearchResultsTopSlotResult {
  return useMemo((): React.ReactNode => {
    if (isTextToImageEngine(selectedEngine)) {
      const { isLoading, isSearching } = engines?.[selectedEngine] || {};

      return (
        <AIGenerationTopSlot
          {...{
            hasQuery,
            onGenerate,
            aspectRatioName,
            colorPaletteState,
            onAspectRatioNameChange,
          }}
          isLoading={isLoading || isSearching}
        />
      );
    }

    return null;
  }, [
    aspectRatioName,
    colorPaletteState,
    engines,
    hasQuery,
    onAspectRatioNameChange,
    onGenerate,
    selectedEngine,
  ]);
}
